import React from 'react'

import style from './style.css'

export default props =>
<div className={`${[props.className, style.aBox].join(' ')}`} style={{ ...props.style }}>
   {props.children}
</div>


// WEBPACK FOOTER //
// ./src/SPRINTA/atoms/Box/index.js